import { Alert, List, ListItem, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export function RnrAlert() {
  const { t } = useTranslation();
  const patterns = useSelector(
    (state: any) => state.settings.internalSettings.rnrPatterns
  );

  function getPatterns(): any[] {
    let array: string[] = [];
    patterns.forEach((element: any) => {
      const stringArray = element.split(":");
      array.push(stringArray[1]);
    });
    return array;
  }
  const [stringArray] = useState<any[]>(getPatterns);

  return (
    <Alert severity="error">
      <Typography>{t("errors.idErrorTitle")}</Typography>
      <List sx={{ listStyleType: 'disc', pl: 4 }}>
        <ListItem style={{ display: 'list-item' }}>{t("errors.incorrectPersonId")}</ListItem>
        {stringArray.map((item: any) => (
          <ListItem style={{ display: 'list-item' }} key={item}>
            {item}
          </ListItem>
        ))}
      </List>
    </Alert>
  );
}
